var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "reg-watch-description-modal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content p-20" }, [
          _c("div", { staticClass: "col-xs-12 p-0 mb-20" }, [
            _c("div", {
              staticClass: "top-header col-xs-10 p-0",
              domProps: { innerHTML: _vm._s(_vm.regWatch.title) },
            }),
            _vm._m(0),
          ]),
          _c("div", {
            staticClass: "modal-body p-10",
            domProps: { innerHTML: _vm._s(_vm.regWatch.longDescription) },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-2 text-right p-0" }, [
      _c("img", {
        staticClass: "cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          alt: "",
          "data-dismiss": "modal",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }